var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PublicKey, clusterApiUrl } from "@solana/web3.js";
import { getProgram } from "./getProgram.obj";
import { ConcurrentMerkleTreeAccount } from "@solana/spl-account-compression";
import { decode, encode } from "bs58";
import { BN } from "@coral-xyz/anchor";
import fetch from "node-fetch";
export function getCNFTData(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var solanaUrl, treeDataReponse, treeData, treeProofResponse, treeProof, connection, treeAccount, treeAuthority, canopyDepth, proofMeta, root, dataHash, creatorHash, nonce, index;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    solanaUrl = clusterApiUrl(Data.Cluster);
                    return [4 /*yield*/, fetch(solanaUrl, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                jsonrpc: "2.0",
                                id: "rpd-op-123",
                                method: "getAsset",
                                params: {
                                    id: Data.tokenId.toString(),
                                },
                            }),
                        })];
                case 1:
                    treeDataReponse = _a.sent();
                    return [4 /*yield*/, treeDataReponse.json()];
                case 2:
                    treeData = (_a.sent()).result;
                    return [4 /*yield*/, fetch(solanaUrl, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                jsonrpc: "2.0",
                                id: "rpd-op-123",
                                method: "getAssetProof",
                                params: {
                                    id: Data.tokenId.toString(),
                                },
                            }),
                        })];
                case 3:
                    treeProofResponse = _a.sent();
                    return [4 /*yield*/, treeProofResponse.json()];
                case 4:
                    treeProof = (_a.sent()).result;
                    console.log("treeProof Results", treeProof);
                    connection = Data.connection
                        ? Data.connection
                        : getProgram({ clusterOrUrl: Data.Cluster }).provider.connection;
                    return [4 /*yield*/, ConcurrentMerkleTreeAccount.fromAccountAddress(connection, new PublicKey(treeProof.tree_id))];
                case 5:
                    treeAccount = _a.sent();
                    treeAuthority = treeAccount.getAuthority();
                    canopyDepth = treeAccount.getCanopyDepth();
                    proofMeta = treeProof.proof
                        .slice(0, treeProof.proof.length - (!!canopyDepth ? canopyDepth : 0))
                        .map(function (node) { return ({
                        pubkey: new PublicKey(node),
                        isSigner: false,
                        isWritable: false,
                    }); });
                    // console.log("proofMeta", proofMeta);
                    // const proof = proofMeta.map((node: AccountMeta) => node.pubkey.toString());
                    // console.log('proof', proof);
                    // console.log('treeProof.root', treeProof.root);
                    console.log("treeData", treeData);
                    root = decode(treeProof.root);
                    dataHash = decode(treeData.compression.data_hash);
                    creatorHash = decode(treeData.compression.creator_hash);
                    nonce = new BN(treeData.compression.leaf_id);
                    index = treeData.compression.leaf_id;
                    // console.log('nonce', nonce);
                    // console.log("args", root, dataHash, creatorHash, nonce, index);
                    console.log("accounts", "\nroot", encode(root), "\ndataHash", encode(dataHash), "\ncreatorHash", encode(creatorHash), "\nnonce", nonce, "\nindex", index, "\ntreeAuthority", treeAuthority.toBase58(), "\nmerkleTree:", new PublicKey(treeProof.tree_id).toString(), "\nproofMeta", proofMeta, "\ncanopyDepth", canopyDepth);
                    return [2 /*return*/, {
                            root: root,
                            dataHash: dataHash,
                            creatorHash: creatorHash,
                            nonce: nonce,
                            index: index,
                            treeAuthority: treeAuthority,
                            merkleTree: new PublicKey(treeProof.tree_id),
                            proofMeta: proofMeta,
                            canopyDepth: canopyDepth,
                        }];
            }
        });
    });
}
export function getProofMeta(proof) {
    return proof.map(function (node) { return ({
        pubkey: new PublicKey(node),
        isSigner: false,
        isWritable: false,
    }); });
}
export function getMerkleTreeAndIndex(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var solanaUrl, treeDataReponse, treeData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    solanaUrl = clusterApiUrl(Data.Cluster);
                    return [4 /*yield*/, fetch(solanaUrl, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                jsonrpc: "2.0",
                                id: "rpd-op-123",
                                method: "getAsset",
                                params: {
                                    id: Data.tokenId.toString(),
                                },
                            }),
                        })];
                case 1:
                    treeDataReponse = _a.sent();
                    return [4 /*yield*/, treeDataReponse.json()];
                case 2:
                    treeData = (_a.sent()).result;
                    // console.log("treeData Results", treeData);
                    // console.log("treeData Results", Data.tokenId, {
                    //     merkleTree: treeData.compression.tree,
                    //     index: treeData.compression.leaf_id,
                    // });
                    if (!!!treeData)
                        throw "No treeData found, verify the tokenId : " + Data.tokenId.toBase58();
                    return [2 /*return*/, {
                            merkleTree: new PublicKey(treeData.compression.tree),
                            index: new BN(treeData.compression.leaf_id),
                        }];
            }
        });
    });
}
export function getCNFTOwner(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var solanaUrl, treeDataReponse, resp, treeData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    solanaUrl = clusterApiUrl(Data.Cluster);
                    return [4 /*yield*/, fetch(solanaUrl, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                jsonrpc: "2.0",
                                id: "rpd-op-123",
                                method: "getAsset",
                                params: {
                                    id: Data.tokenId.toString(),
                                },
                            }),
                        })];
                case 1:
                    treeDataReponse = _a.sent();
                    return [4 /*yield*/, treeDataReponse.json()];
                case 2:
                    resp = _a.sent();
                    console.log("resp", resp);
                    treeData = resp.result;
                    console.log("treeData Results", treeData);
                    if (!treeData.compression.compressed)
                        throw "not cNFT";
                    return [2 /*return*/, new PublicKey(treeData.ownership.owner)];
            }
        });
    });
}
